class SessionService {
    constructor() {
      this.tokenKey = 'admin_token';
      this.refreshTokenKey = 'admin_refresh_token';
      this.tokenExpiryKey = 'admin_token_expiry';
      this.refreshInterval = null;
    }
  
    setSession(token, refreshToken, expiresIn = 3600) {
      const expiryTime = new Date().getTime() + expiresIn * 1000;
      
      localStorage.setItem(this.tokenKey, token);
      localStorage.setItem(this.refreshTokenKey, refreshToken);
      localStorage.setItem(this.tokenExpiryKey, expiryTime.toString());
  
      this.setupRefreshInterval();
    }
  
    clearSession() {
      localStorage.removeItem(this.tokenKey);
      localStorage.removeItem(this.refreshTokenKey);
      localStorage.removeItem(this.tokenExpiryKey);
      
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
    }
  
    getToken() {
      return localStorage.getItem(this.tokenKey);
    }
  
    getRefreshToken() {
      return localStorage.getItem(this.refreshTokenKey);
    }
  
    isSessionValid() {
      const token = this.getToken();
      const expiry = localStorage.getItem(this.tokenExpiryKey);
      
      if (!token || !expiry) {
        return false;
      }
  
      return new Date().getTime() < parseInt(expiry);
    }
  
    setupRefreshInterval() {
      // Clear any existing interval
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
  
      // Set up new refresh interval
      this.refreshInterval = setInterval(async () => {
        try {
          if (!this.isSessionValid()) {
            await this.refreshToken();
          }
        } catch (error) {
          console.error('Token refresh failed:', error);
          this.clearSession();
          window.location.href = '/admin/login';
        }
      }, 5 * 60 * 1000); // Check every 5 minutes
    }
  
    async refreshToken() {
      const refreshToken = this.getRefreshToken();
      
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }
  
      const response = await fetch('/api/admin/auth/refresh-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          refreshToken
        })
      });
  
      if (!response.ok) {
        throw new Error('Token refresh failed');
      }
  
      const data = await response.json();
      this.setSession(data.token, data.refreshToken, data.expiresIn);
      
      return data.token;
    }
  }
  
  export default new SessionService();